import { type FC } from 'react'
import { type Booking } from '../../../models/Scheduling'
import { formatDate } from '../../../common/dateUtils'
import { formatBookingDate, formatTimeRange } from '../bookingFormat'

// Left-hand date/time block of a booking row: "APR 24, 2026" over the time range, with the
// "was Apr 24" indicator on rescheduled bookings. noTimeLabel covers rows without a time yet.
export const BookingTimeBlock: FC<{ booking: Booking; noTimeLabel?: string }> = ({ booking, noTimeLabel = 'No time set' }) => {
  if (!booking.start || !booking.end) {
    return <div className='paragraph-small zocks-text-gray-600'>{noTimeLabel}</div>
  }
  const start = new Date(booking.start)
  return (
    <div className='d-flex flex-column'>
      <div className='paragraph-small zocks-text-gray-500 text-nowrap'>{formatBookingDate(start)}</div>
      <div className='paragraph-small zocks-text-gray-900 text-nowrap'>{formatTimeRange(booking.start, booking.end)}</div>
      {booking.originalStart ? (
        <div className='paragraph-small zocks-text-gray-500 d-inline-flex align-items-center zocks-gap-0.25'>
          was {formatDate(new Date(booking.originalStart))}
          <i className='bi bi-arrow-repeat' />
        </div>
      ) : null}
    </div>
  )
}
